/* eslint-disable no-console */
import { connect } from 'react-redux';
import initWrapper from '../initWrapper';

import {
  dataInit,
  dataLoad,
  // dataFilterRemove,
  // dataFilterEdit,
  // dataFilterAdd,
  dataPageSize,
  dataPage,
  dataSort,
  dataOrder,
  // dataFilterOpen,
} from './localActions';

export const Order = { DESC: 'DESC', ASC: 'ASC' };

export default (dataId, defaultProps, Component) => {
  const mapStateToProps = ({ grid }) => grid[dataId];

  const mapDispatchToProps = dispatch => ({
    onLoad: () => dispatch(dataLoad(dataId)),
    // onFilterRemove: filter => dispatch(dataFilterRemove(dataId, filter)),
    // onFilterEdit: (filter, newFilter) => dispatch(dataFilterEdit(dataId, filter, newFilter)),
    // onFilterAdd: () => dispatch(dataFilterAdd(dataId)),
    onPageSizeChange: size => dispatch(dataPageSize(dataId, size)),
    onPageChange: page => dispatch(dataPage(dataId, page)),
    onSortChange: sort => dispatch(dataSort(dataId, sort)),
    onOrderChange: order => dispatch(dataOrder(dataId, order)),
    // onFilterOpen: isOpen => dispatch(dataFilterOpen(dataId, isOpen)),
  });

  return initWrapper(dataInit(dataId, defaultProps), connect(mapStateToProps, mapDispatchToProps)(Component));
};
